// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_summary__mAryN {
    width: 1650px;
    max-width: 100%;
}

.styles_container__sw7FT {
    width: 100%;
    margin: 11px auto 60px;
    /*padding: 0 20px;*/
    display: grid;
    grid-template-columns: repeat(3, 1fr);
}

.styles_footer__nrnhy {
    display: flex;
    justify-content: space-between;
}

.styles_item__ah3p7 {
    height: 300px;
    border: 0.5px solid #1650b4;
    padding: 24px 12px;
    position: relative;
    background: #fff;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    overflow: hidden;
}

.styles_item__ah3p7.styles_selected__Ehl56 {
    /*background: linear-gradient(#fff, #f2f3f4);*/
    background: var(--primary-color-light);
}

.styles_index__ryd5a {
    position: absolute;
    font-size: 30px;
    font-weight: 300;
    top: 24px;
}

.styles_header__RLozQ {
    /*font-size: 20px;*/
    text-align: center;
    margin-bottom: 35px;
}

.styles_lines__w5VfN {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
}

/*.item.selected .header {*/
/*    color: #0c3b8d;*/
/*}*/

.styles_item__ah3p7.styles_selected__Ehl56 .styles_header__RLozQ {
    margin: 40px auto 16px;
}

.styles_item__ah3p7:not(.styles_selected__Ehl56) .styles_header__RLozQ {
    margin: auto;
}

.styles_subheader__TU7Ql {
    display: block;
    text-align: center;
    /*font-size: 22px;*/
    line-height: 30px;
    /*font-weight: 300;*/
    max-width: 100%;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    /*text-wrap: nowrap;*/
}

.styles_domicile__JhPEw {
    text-align: center;
    /*font-size: 22px;*/
    line-height: 38px;
    font-weight: 300;
    font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Storage/StorageForm/components/StorageFormSummary/styles.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,sCAAsC;AAC1C;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B,sBAAsB;AACtB,IAAI;;AAEJ;IACI,sBAAsB;AAC1B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,oBAAoB;IACpB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB","sourcesContent":[".summary {\n    width: 1650px;\n    max-width: 100%;\n}\n\n.container {\n    width: 100%;\n    margin: 11px auto 60px;\n    /*padding: 0 20px;*/\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n}\n\n.footer {\n    display: flex;\n    justify-content: space-between;\n}\n\n.item {\n    height: 300px;\n    border: 0.5px solid #1650b4;\n    padding: 24px 12px;\n    position: relative;\n    background: #fff;\n    display: flex;\n    flex-direction: column;\n    cursor: pointer;\n    overflow: hidden;\n}\n\n.item.selected {\n    /*background: linear-gradient(#fff, #f2f3f4);*/\n    background: var(--primary-color-light);\n}\n\n.index {\n    position: absolute;\n    font-size: 30px;\n    font-weight: 300;\n    top: 24px;\n}\n\n.header {\n    /*font-size: 20px;*/\n    text-align: center;\n    margin-bottom: 35px;\n}\n\n.lines {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 5;\n    overflow: hidden;\n}\n\n/*.item.selected .header {*/\n/*    color: #0c3b8d;*/\n/*}*/\n\n.item.selected .header {\n    margin: 40px auto 16px;\n}\n\n.item:not(.selected) .header {\n    margin: auto;\n}\n\n.subheader {\n    display: block;\n    text-align: center;\n    /*font-size: 22px;*/\n    line-height: 30px;\n    /*font-weight: 300;*/\n    max-width: 100%;\n    /*overflow: hidden;*/\n    /*text-overflow: ellipsis;*/\n    /*text-wrap: nowrap;*/\n}\n\n.domicile {\n    text-align: center;\n    /*font-size: 22px;*/\n    line-height: 38px;\n    font-weight: 300;\n    font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"summary": `styles_summary__mAryN`,
	"container": `styles_container__sw7FT`,
	"footer": `styles_footer__nrnhy`,
	"item": `styles_item__ah3p7`,
	"selected": `styles_selected__Ehl56`,
	"index": `styles_index__ryd5a`,
	"header": `styles_header__RLozQ`,
	"lines": `styles_lines__w5VfN`,
	"subheader": `styles_subheader__TU7Ql`,
	"domicile": `styles_domicile__JhPEw`
};
export default ___CSS_LOADER_EXPORT___;
